<template>
    <router-view transition="fade-transition"></router-view>
</template>

<script>
    export default {
        mounted() {
        }
    }
</script>